module.exports = __webpack_public_path__ + "img/timelineWhite.8bdb2ff6.svg";